
import * as DomBuilder from "../gui/dom-builder.js";
import DataProviderAPI from "../DataProviderAPI.js";
import DataProviderLocalStorage from "../DataProviderLocalStorage";
import DataManager from "../DataManager.js";
import Dataset from "../Dataset";
import Controller from "../Controller";
import ComponentTabbedPanel from "../gui/ComponentTabbedPanel.js";
import ComponentPanelFilters from "../gui/ComponentPanelFilters.js";
import ComponentPanelDatasets from "../gui/ComponentPanelDatasets.js";
import ComponentPanelAnalysis from "../gui/ComponentPanelAnalysis.js";
import ComponentPanelPersistenceAPI from "../gui/ComponentPanelPersistenceAPI.js";
import ComponentPanelPersistenceLocalStorage from "../gui/ComponentPanelPersistenceLocalStorage";
import ComponentPanelLog from "../gui/ComponentPanelLog.js";
import ServerPrivateAPI from "../ServerPrivateAPI";
import DialogNotificationProvider from "../gui/DialogNotificatonProvider";
import Logger from "../Logger.js";

import EXAMPLE_DATA from "../../examples/data_simple.csv";
import EXAMPLE_FILTER from "../../examples/filters.json";

export function builder() {
    return new Builder();
}

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
class Builder {

    /** @type {DataProvider|null} */
    #dataProvider = null;
    /** @type {boolean} */
    #urlDatasetEnabled = false;
    /** @type {boolean} */
    #categoriesEnabled = (window.innerWidth >= 1200);

    setPersistenceLocalStorage() {
        let datasets = new Map();
        datasets.set('example', new Dataset('example', 'csv-simple', EXAMPLE_DATA));
        this.#dataProvider = new DataProviderLocalStorage(EXAMPLE_FILTER, datasets);
        return this;
    }

    setPersistenceHttp(csrfParameterName, csrfToken) {
        this.#dataProvider = new DataProviderAPI();
        ServerPrivateAPI.csrfParameterName = csrfParameterName;
        ServerPrivateAPI.csrfToken = csrfToken;
        return this;
    }

    setCategoriesEnabled(enabled) {
        this.#categoriesEnabled = enabled;
        return this;
    }

    setUrlDatasetsEnabled(enabled) {
        this.#urlDatasetEnabled = enabled;
        return this;
    }

    build() {
        if (this.#dataProvider === null) {
            throw 'Data provider not set';
        }

        const dialogAnchorNode = DomBuilder.div({ class: 'finance-dialog-anchor finance-component' });
        document.body.prepend(dialogAnchorNode);

        let logger = new Logger();
        let notificationProvider = new DialogNotificationProvider(dialogAnchorNode, logger);
        let dataManager = new DataManager(this.#dataProvider, this.#urlDatasetEnabled, notificationProvider, logger);
        let controller = new Controller(dialogAnchorNode, dataManager, logger);

        let componentTabbedPanel = new ComponentTabbedPanel();
        componentTabbedPanel.addPanel(new ComponentPanelDatasets(controller));
        componentTabbedPanel.addPanel(new ComponentPanelFilters(controller));
        componentTabbedPanel.addPanel(new ComponentPanelAnalysis(controller, this.#categoriesEnabled));
        componentTabbedPanel.addPanel(new ComponentPanelLog(controller));
        if (this.#dataProvider instanceof DataProviderLocalStorage) {
            componentTabbedPanel.addPanel(new ComponentPanelPersistenceLocalStorage(controller));
        } else {
            componentTabbedPanel.addPanel(new ComponentPanelPersistenceAPI(controller));
        }

        let node = componentTabbedPanel.createNode();
        node.classList.add('finance-component');
        setTimeout(() => dataManager.load());
        return node;
    }
}
